import './NavItem.scss'

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface NavItemProps {
  disabled?: boolean
  href?: string
  isActive?: boolean
  onClick?: ()=> void
  target?: string
  title: string
}

const NavItem = (props: NavItemProps)=> {
  const { t } = useTranslation()
  const [isTooltipVisible, setIsTooltipVisible] = useState(false)
  const { isActive, disabled, title, href, target, onClick } = props

  const onMouseEnter = () => {
    if (!isTooltipVisible) {
      setIsTooltipVisible(true)
    }
  }

  const onMouseLeave = () => {
    if (isTooltipVisible) {
      setIsTooltipVisible(false)
    }
  }

  const NavItemLink = () => {
    const className = disabled ? 'header__nav_item_disabled' : 'header__nav_item'

    if (isActive || disabled) {
      return (
        <span
          className={className}
          onMouseEnter={disabled === true ? onMouseEnter : undefined}
          onMouseLeave={disabled === true ? onMouseLeave : undefined}
        >
          {title}
        </span>
      )
    }

    if (href) {
      return (
        <a className={className} href={href} onClick={onClick} target={target || '_self'}>
          {title}
        </a>
      )
    }

    return (
      <button className={className} onClick={onClick} type="button">
        {title}
      </button>
    )
  }

  return (
    <div className="header__nav_item_wrapper">
      <NavItemLink />
      {disabled && (
        <div
          className={
            isTooltipVisible
              ? 'header__nav_item_disabled_tooltip_visible'
              : 'header__nav_item_disabled_tooltip_hidden'
          }
        >
          {t('header.featureDisabled', { feature: title })}
        </div>
      )}
      {isActive && <span className="header__nav_selected_underline" />}
    </div>
  )
}

export default NavItem
